import IHistoryData, { IPreviewHistoryData } from '../../../../../tableEngine/Script/Game/Data/DataObject/History/IHistoryData';
import Lobby from '../../../../System/Lobby';
import { LobbyGamePreviewData } from '../../Model/LobbyHallModel';

export default class PreviewHistoryData implements IPreviewHistoryData {
    public readonly gameID: string;
    public readonly machineID: number;
    public readonly machineName: string;
    public readonly win: number;
    public readonly bet: number;
    public readonly timestamp: number;

    public readonly betCount: number;

    constructor(gameID: string, arcadeID: number, rawDatas: IHistoryData[]) {
        this.gameID = gameID;
        this.machineID = arcadeID;
        this.machineName = this._getGamePreviewData()?.DisplayName;

        let bet = 0;
        let win = 0;
        let lastTime = 0;
        rawDatas.forEach((data) => {
            bet += data.bet;
            win += data.win;
            if (data.timestamp > lastTime) {
                lastTime = data.timestamp;
            }
        });
        this.bet = bet;
        this.win = win;
        this.timestamp = lastTime;
        this.betCount = rawDatas.length;
    }

    private _getGamePreviewData(): LobbyGamePreviewData {
        return Lobby.hall.getGameDataByID(Lobby.hall.currentHallID, this.gameID, Lobby.history.currentRecordType) as LobbyGamePreviewData;
    }
}
